import { KpiInfo } from '@blisspointmedia/bpm-types/dist/Kpis';

export const NAME_DIMENSION = 'name';
export const KPI_LABEL = 'KPI';
export const TYPE_DIMENSION = 'Type';

export const NON_DIMENSION_KEYS: ReadonlySet<string> = new Set(['id', 'linearHidden']);

export const COMMERCE_DEFAULT_KPI = 'orders';
export const COMMERCE_KPI_MAP: Record<string, KpiInfo> = {
  [COMMERCE_DEFAULT_KPI]: { id: COMMERCE_DEFAULT_KPI, name: 'Orders' },
  units: { id: 'units', name: 'Units' },
  new_to_brand_orders: { id: 'new_to_brand_orders', name: 'New to Brand Orders' },
  dpv: { id: 'dpv', name: 'DPV' },
  sns: { id: 'sns', name: 'Subscribe and Save' },
  branded_searches: { id: 'branded_searches', name: 'Branded Searches' }
};

export const MediaType = {
  STREAMING: 'streaming',
  YOUTUBE: 'youtube',
  COMMERCE: 'commerce'
} as const;

export interface KpiDimensionOption {
  dimension: string;
  value: string;
  options: string[];
}
